/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetToolResult } from '../../models/get-tool-result';

export interface ApiToolsIdGet$Params {
  id: string;

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiToolsIdGet(http: HttpClient, rootUrl: string, params: ApiToolsIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolResult>> {
  const rb = new RequestBuilder(rootUrl, apiToolsIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetToolResult>;
    })
  );
}

apiToolsIdGet.PATH = '/api/Tools/{id}';
